import React from 'react';
import { Box } from '@mui/system';

import { Header } from 'components/Header';
import {
  StyedDefaultWrapper,
  StyledChildrenWrapper,
  StyledContent,
} from './styles';
import Breadcrumb from 'components/Breadcrumb';

const DefaultWrapper = ({
  children,
  crumbs = [],
  showHeader = false,
  margin,
  sx = { maxWidth: '1380px', margin: { xl: 'auto' } }
}) => {
  return (
    <Box>
      <StyedDefaultWrapper>
        {showHeader && <Header />}
        {crumbs.length > 0 && <Breadcrumb
          crumbs={crumbs}
        />}
        <StyledContent
          sx={sx}
          margin={margin}>
          <StyledChildrenWrapper>{children}</StyledChildrenWrapper>
        </StyledContent>
      </StyedDefaultWrapper>
    </Box>
  );
};

export default DefaultWrapper;
